import { useState } from 'react'
import { Edit, useTranslate } from 'react-admin'

import { BackFromEditorButton } from 'components/common/BackFromEditorButton'

import PackageForm from '../PackageForm/PackageForm'

const PackageEdit = () => {
    const translate = useTranslate()
    const [isPristineForm, setIsPristineForm] = useState(true)

    return (
        <>
            <BackFromEditorButton isPristineForm={isPristineForm} backToRouteURL="/package" />
            <Edit title={translate('manager.resources.package.edit')}>
                <PackageForm
                    isPristineForm={isPristineForm}
                    setIsPristineFormCallback={setIsPristineForm}
                    isEdit={true}
                />
            </Edit>
        </>
    )
}

export default PackageEdit
